import React, { useEffect } from "react";
import { useTheme } from "@emotion/react";

export const namedComponent = <T,>(name: string, component: React.FC<T>) => {
  // eslint-disable-next-line no-param-reassign
  component.displayName = name;
  return component;
};

export const switchComponent = (Dark: React.FC, Light: React.FC) =>
  namedComponent("themeSwitched", (props: any) => {
    const theme = useTheme();
    if (theme.mode === "dark") {
      return <Dark {...props} />;
    }
    return <Light {...props} />;
  });

export interface StatefullData<T> {
  state: "empty" | "loading" | "loaded" | "error";
  data: T | null;
  error?: any;
}
